import isString from 'lodash/isString'
import React, { useCallback, useContext, useMemo } from 'react'

import { ampli } from '@Analytics/ampli'
import { CheckoutModalContext } from '@Domains/Checkout/Providers/CheckoutModalProvider'
import { PaymentError } from '@Domains/Checkout/Steps/Payment/Components/PaymentError/PaymentError'
import { PaymentResponseCallback } from '@Domains/CheckoutV2/Features/CheckoutSteps/Contexts/typings/CheckoutFlowTypes'
import { useTranslation } from '@Globals/Translations'
import { CheckoutV2FinalizeCartResult } from '@Pages/onestepcheckout'
import { useDefaultCheckoutResponse } from '@PaymentComponents/Default/hooks/useDefaultCheckoutResponse'

export const useByJunoCheckoutResponse = () => {
  const {
    setModal,
    unSetModal,
  } = useContext(CheckoutModalContext)
  const { t } = useTranslation()
  const { handlePaymentSubmitResponse } = useDefaultCheckoutResponse()

  const hasError = res => !res || !res.success

  const handleByJunoRedirect = useCallback((response) => {
    const byJunoResponse = response.paymentPayload
    if (hasError(response)) {
      return false
    }
    const { redirect } = byJunoResponse
    if (redirect) {
      window.location.href = isString(redirect) ? redirect : redirect?.url
      return true
    }
    return false
  }, [])

  const handleByJunoError = useCallback((response, paymentType: string) => {
    if (hasError(response)) {
      ampli.cofCompletionFailRes({
        payment_method: paymentType,
      })
      setModal(<PaymentError closeModal={unSetModal} error={t('common:SOMETHING_WENT_WRONG_PLEASE_CONTACT_US')} />)
      return true
    }
    return false
  }, [setModal, t, unSetModal])

  const handleByJunoPaymentSubmitResponse: PaymentResponseCallback = useCallback((paymentType: string, response: CheckoutV2FinalizeCartResult) => {
    let res: boolean = handleByJunoRedirect(response)
    res = res || handleByJunoError(response, paymentType)
    res = res || handlePaymentSubmitResponse(paymentType, response)
    return res
  }, [handleByJunoError, handleByJunoRedirect, handlePaymentSubmitResponse])
  const value = useMemo(() => ({ handleByJunoPaymentSubmitResponse }), [handleByJunoPaymentSubmitResponse])

  return value
}
